/** Maximum character count accepted by the chat message input. */
export const MAX_INPUT_LENGTH = 512;

/**
 * How many conversations a "recents" list shows. Shared so every consumer issues the *same*
 * `useConversationsList` query and reads one cache entry — `useActiveConversationTitle` depends on
 * that to look the active conversation's name up without triggering a request of its own.
 */
export const RECENT_CONVERSATIONS_LIMIT = 10;
